module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Photovoltaik","pvProduction":"PV-Produktion","total":"Absolut","share":"Anteil","type":{"el_ownuse":"PV-Eigenverbrauch","el_feedin":"PV-Rückspeisung"}}}')
  delete Component.options._Ctor
}
